import React, { useRef, useState, useEffect } from 'react';
import LcDropDown from '../../../../components/Generic/LcDropDown';
import { useSelector, useDispatch } from 'react-redux';
import { SolicitationFilterDashboard } from "../../../../models/SolicitationFilter";
import DashboardFilters from '../DashboardFilters';
import LcIconLink from '../../../../components/Generic/LcIconLink';
import { PrefState } from '../../../../store/reducers/prefReducer';
import { RootState } from '../../../../store';
import TextTools from '../../../../services/TextTools/TextTools';
import { Period } from "../../../../models/Period";
import { PPDropDown, PPToggle } from 'processor-plataform-ui';
import moment from 'moment';
import "./index.css";

interface Props {
    businessAreaList: any[],
    toggle: boolean,
    setToggle: Function,
    setClear: Function,
    detailed: boolean,
    setDetailed: Function,
    setLoading: Function
    loading: boolean
}

const DashboardHeader: React.FC<Props> = (props) => {
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();
    const selectionRef = useRef<any>(null);
    const selectPeriodFiltersRef = useRef<any>(null);
    const selectionAreaRef = useRef<any>(null);
    const selectionCompRef = useRef<any>(null);
    const selectPeriodFiltersAreaRef = useRef<any>(null);
    const selectPeriodFiltersCompetenceRef = useRef<any>(null);
    const [selection, setSelection] = useState<Period>();
    const [selectionArea, setSelectionArea] = useState<Period>();
    const [selectionCompetence, setSelectionCompetence] = useState<string>("Sem competência");
    const [businessAreaSelectionsList, setBusinessAreaSelectionsList] = useState<any[]>([]);
    const [date, setDate] = useState<any>({
        year: new Date().getFullYear(),
        month: ((new Date().getMonth() + 1) > 10) ? new Date().getMonth() + 1 : "0" + (new Date().getMonth() + 1)
    });
    const [loading, setLoading] = useState<boolean>(false);

    const textTools = new TextTools();

    const [yearList, setYearList] = useState<any[]>([
        // { label: "2020", value: "2020" },
        // { label: "2021", value: "2021" },
        { label: "2022", value: "2022" },
        { label: "2023", value: "2023" },
        { label: "2024", value: "2024" },
    ]);

    const [monthList, setMonthList] = useState<any[]>([
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
    ]);

    const selectionsList = [
        {
            label: 'Todos os chamados',
            text: 'Todos os chamados',
            default: (pref.solicitationTypeDash === 'all' || !pref.solicitationTypeDash),
            fields: [{ name: 'all', value: "all" }]
        },
        {
            label: 'Chamados de hoje',
            text: 'Chamados de hoje',
            default: (pref.solicitationTypeDash === 'today'),
            fields: [{ name: 'today', value: "today" }]
        },
        {
            label: 'Chamados da semana',
            text: 'Chamados da semana',
            default: (pref.solicitationTypeDash === 'week'),
            fields: [{ name: 'week', value: "week" }]
        },
        {
            label: 'Chamados deste mês',
            text: 'Chamados deste mês',
            default: (pref.solicitationTypeDash === 'month'),
            fields: [{ name: 'month', value: "month" }]
        },
        {
            label: 'Chamados do mês anterior',
            text: 'Chamados do mês anterior',
            default: (pref.solicitationTypeDash === 'lastMonth'),
            fields: [{ name: 'lastMonth', value: "lastMonth" }]
        }
    ];

    useEffect(() => {
        let selectionActive = selectionsList.find(ps => {
            return ps.default === true
        });

        if (selectionActive) setSelection(selectionActive);
    }, [pref.solicitationTypeDash]);

    useEffect(() => {
        let selectionActive = businessAreaSelectionsList.find(ps => {
            return ps.default === true
        });

        if (selectionActive) setSelectionArea(selectionActive);
    }, [businessAreaSelectionsList]);

    useEffect(() => {
        let selectionActive = businessAreaSelectionsList.find(ps => {
            return ps.default === true
        });

        if (selectionActive) setSelectionArea(selectionActive);
    }, [businessAreaSelectionsList]);

    useEffect(() => {
        if (pref.competenceDash === undefined || pref.competenceDash === null) {
            const date = moment(new Date());
            const month = (date.month() + 1 < 10) ? "0" + (date.month() + 1) : date.month() + 1;
            dispatch({ type: "PREF_COMPETENCE_DASH", payload: `${date.year()}/${month}` });
            setDate({ year: date.year(), month: month });
        }
    }, [])

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading])

    useEffect(() => {
        const _date = moment(`${(pref.competenceDash == null) ? new Date() : pref.competenceDash}/01`);
        const regex = /\b(\d)\b/g;

        // year: new Date().getFullYear(),
        // month: ((new Date().getMonth() + 1) > 10) ? new Date().getMonth() + 1 : "0" + (new Date().getMonth() + 1)

        setDate({
            year: _date.year(),
            month: (_date.month() + 1).toString().replace(regex, "0$1")
        });

        setSelectionCompetence((pref.competenceDash == null)
            ? "Sem competência"
            : `Competência - ${pref.competenceDash}`
        );
    }, [pref.competenceDash])

    const onChangeSelection = (period: Period) => {
        setSelection(period);
        dispatch({ type: "PREF_SOLICITATIONTYPE_DASH", payload: period.fields && period?.fields[0].value });
    }

    const onChangeSelectionArea = (period: Period) => {
        setSelectionArea(period);
        setBusinessAreaSelectionsList(textTools.mountDropAreaSelectionList(props.businessAreaList, period.fields && period.fields[0].value))
        dispatch({ type: "PREF_BUSINESSAREA_DASH", payload: period.value });
    }

    useEffect(() => {
        var valueSelected = 0;

        if (pref.businessAreaDash) {
            valueSelected = pref.businessAreaDash;
        }
        else if (props.businessAreaList.length === 1) {
            valueSelected = props.businessAreaList[0].id;
        }

        setBusinessAreaSelectionsList(textTools.mountDropAreaSelectionList(props.businessAreaList, valueSelected));
    }, [props.businessAreaList, pref.businessAreaDash]);

    const handleClear = () => {
        props.setClear(true);
        dispatch({ type: "PREF_BUSINESSAREA_DASH", payload: null });
        dispatch({ type: "PREF_SOLICITATIONTYPE_DASH", payload: null });
        dispatch({ type: "PREF_COMPETENCE_DASH", payload: null });
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setDate({ ...date, [name]: value });
    }

    const [open, setOpen] = useState<boolean>(false);
    const handleOk = () => {
        setOpen(false);
        dispatch({ type: "PREF_COMPETENCE_DASH", payload: `${date.year}/${date.month}` });
    }

    const handleClearCompentence = () => {
        setOpen(false);
        // setDate(undefined);

        setDate({
            year: new Date().getFullYear(),
            month: ((new Date().getMonth() + 1) > 10) ? new Date().getMonth() + 1 : "0" + (new Date().getMonth() + 1)
        });

        dispatch({ type: "PREF_COMPETENCE_DASH", payload: null });
    }

    return (
        <>
            <LcDropDown
                id={"selectPeriodFilters"}
                maxHeight={'60vh'}
                element={
                    <span
                        className={(loading) ? "select-period disabled" : "select-period"}
                        ref={selectionRef}>
                        &nbsp;{selection?.text}
                        <i className={"ppi ppi-chevron-down-alt"} style={{ margin: "10px" }} />
                    </span>
                }
                disabled={loading}
            >
                {
                    selectionsList.map((p, i) => {
                        return (
                            <span
                                key={i}
                                className="item"
                                onClick={() => onChangeSelection(p)}
                                ref={selectPeriodFiltersRef}
                            >
                                {p.label}
                            </span>
                        )
                    })
                }
            </LcDropDown>

            <LcDropDown
                id={"selectPeriodFilters"}
                maxHeight={'60vh'}
                element={
                    <span
                        className={(loading) ? "select-period disabled" : "select-period"}
                        ref={selectionAreaRef}>
                        &nbsp;{selectionArea?.text}
                        <i className={"ppi ppi-chevron-down-alt"} style={{ margin: "10px" }} />
                    </span>
                }
                disabled={loading}
            >
                {
                    businessAreaSelectionsList.map((p, i) => {
                        return (
                            <span
                                key={i}
                                className={"item"}
                                onClick={() => onChangeSelectionArea(p)}
                                ref={selectPeriodFiltersAreaRef}
                            >
                                {p.label}
                            </span>
                        )
                    })
                }
            </LcDropDown>

            <LcDropDown
                id={"selectPeriodFilters"}
                maxHeight={'60vh'}
                element={
                    <span
                        className={(loading) ? "select-period disabled" : "select-period"}
                        ref={selectionCompRef}
                        onClick={() => setOpen(!open)}>
                        &nbsp;{selectionCompetence}
                        <i className={"ppi ppi-chevron-down-alt"} style={{ margin: "10px" }} />
                    </span>
                }
                disabled={loading}
                hold={true}
                visible={open}
                trigger={"click"}
                overflow={false}
                setvisible={setOpen}
            >
                <div className={"row start"} style={{ marginBottom: '10px' }}>
                    <PPDropDown
                        value={date.year}
                        name={"year"}
                        onChange={handleChange}
                        options={yearList}
                        placeholder={'Ano'}
                        width={"75px"}
                        hideFilter
                    />

                    <PPDropDown
                        value={date.month}
                        name={"month"}
                        onChange={handleChange}
                        options={monthList}
                        placeholder={'Mês'}
                        width={"75px"}
                        hideFilter
                    />
                </div>
                <div className={"row start space-between"}>
                    <button
                        style={{ width: "75px" }}
                        className={"lc-button bg-primary"}
                        onClick={() => handleOk()}
                    >
                        Ok
                    </button>
                    <button
                        style={{
                            width: '75px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        className={"lc-button bg-primary"}
                        onClick={() => handleClearCompentence()}
                    >
                        Limpar
                    </button>
                </div>
            </LcDropDown>

            <div className={"row between"}>
                <div style={{ display: "flex" }}>
                    <LcIconLink
                        icon={"ppi ppi-filter"}
                        onClick={() => props.setToggle(!props.toggle)}
                        activedAfterClick={props.toggle}
                        tooltip={"Mais filtros"}
                    />
                    <LcIconLink
                        icon={"ppi ppi-restore"}
                        size={"mediumBigFont"}
                        onClick={() => handleClear()}
                        tooltip={"Limpar filtros"}
                        disabled={loading}
                    />
                </div>

                <PPToggle
                    toggled={props.detailed}
                    name={"Detalhado"}
                    title={"Detalhado"}
                    onChange={() => props.setDetailed(!props.detailed)}
                />
            </div>
        </>
    );
};

export default DashboardHeader;